import React from 'react';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import Button from '../common/ui-components/input/Button';
import  ChildPlanList from '../common/ChildPlanList';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import styles from '../../styles/modules/components/SelfServe/confirm-sr-details.module.scss';
import {
    changeTrackerState,
    changeProgress,
    previousStepProgress,
    restoreFromTicketList,
    removeAddDevice,
    updateDeviceDetails,
    updateEditScreenDetails,
} from '../../redux/actions/selfserveActions';
import { HOMECARE_PLANS, HOMECARE_PLAN_LIST, HOMECARE_FEST_MAX_CLAIMS } from '../../constants/index';
import AddDeviceModal from './AddDeviceModal';
import ConfirmDeleteDeviceModel from './ConfirmDeleteDeviceModel';


interface ReduxStateProps {
    selfserveReducer: any,
}

interface MainProps {
    setPageLoading: (data:Boolean) => void
}

type Props = ReduxStateProps & MainProps;

const DeviceInformation = (props: Props) => {
    const {
        addressPageFrom,
        parentPlanDetails: {
            plan_name: planName,
            button_disabled: buttonDisabled,
        },
        planCovers,
        planDetails,
        previousStepList,
        editScreen,
        ticket_list:ticketList,
        current_ticket_key:currentTicketKey,
        landed_on_page,
     } = props.selfserveReducer
    const dispatch:any = useDispatch()

    useEffect(() => {
        // check thi both thing
        dispatch(changeTrackerState(3));
        window.scrollTo({top:0,left:0,'behavior': 'smooth'});

    }, [])
    const [, setCoversNo] = useState(planCovers.length);
    const [disableBtn, setDisableBtn] = useState<boolean>(buttonDisabled ? buttonDisabled : true);
    const [disableAddNewDevice, setDisableAddNewDevice] = useState<boolean>(true);

    const [deviceDetails, setDeviceDetails] = React.useState<object>({});
    const [isOpenDeviceModel, setIsOpenDeviceModel] = useState(false);
    const [deleteDeviceKey, setDeleteDeviceKey] = useState<String>('');
    const [isOpenDeviceDeleteModel, setIsOpenDeviceDeleteModel] = useState(false);
    const [showChildPlan, setShowChildPlan] = useState(false);

    const handleEditOption = (step,osid: any = planDetails.osid) => {
        let key = `${osid}`;
        dispatch(restoreFromTicketList(key))
        dispatch(changeProgress(step))
        dispatch(updateEditScreenDetails(15,key))
        if(step === 14) dispatch(removeAddDevice(key));
    }

    const handleRaiseNewSR = ()=>{
        if (getMaxClaimValidity()) {
          setShowChildPlan(!showChildPlan)
          dispatch(updateDeviceDetails({},false))
        }
    }

    const handleButton = (e) => {
        e.preventDefault();
        //here add one more condition related to select device or just select device in hcb
        //check disable flag handler other way
        if (HOMECARE_PLAN_LIST.includes(planName) && !disableBtn) {
            dispatch(changeProgress(4));
        }else{
            dispatch(changeProgress(7));
        }
    }
    const getProblemsList =(serviceRequests:any)=> {

        const customIssue = serviceRequests[0].hasOwnProperty('custom_issue') ? serviceRequests[0].custom_issue : ''
        const problems = customIssue === '' ? serviceRequests[0].selected_problems : [...serviceRequests[0].selected_problems, customIssue]
        return problems
    }

    const getDeviceName = (osid) => {
      let deviceName = ""

      if (ticketList[osid].deviceDetails.hasOwnProperty('category_type')) {
        deviceName = ticketList[osid].deviceDetails.device_name
        ? `${ticketList[osid].deviceDetails.device_name} (${ticketList[osid].deviceDetails.category_type})`
        : ticketList[osid].deviceDetails.category_type
      } else {
        deviceName = ticketList[osid].planDetails.category_type
      }

      return deviceName;
    }
    const removeDevice =(osid) =>{
        setDeleteDeviceKey(osid)
        setIsOpenDeviceDeleteModel(!isOpenDeviceDeleteModel)
    }

    const getCategoryText = (osid) => {
      let category_text = ticketList[osid].deviceDetails?.category ? ticketList[osid].deviceDetails.category : ticketList[osid].planDetails.category;
      if (category_text === getDeviceName(osid)) {
        return '';
      } else {
        return category_text;
      }
    }

    const getMaxClaimValidity = () => {
      let currentSrs = Object.keys(props.selfserveReducer.ticket_list).length;
      if (!currentSrs) {
        currentSrs = 0;
      }

      if (props.selfserveReducer.parentPlanDetails.plan_name === "HomeCare Fest") {
        return ((props.selfserveReducer.parentPlanDetails.total_claims + currentSrs) < HOMECARE_FEST_MAX_CLAIMS)
      } else {
        return true;
      }
    }

    return (
        <div className={styles.confirm_parent}>
            <div className={commonStyles.top_heading}>
                <h5>Selected Devices</h5>
            </div>
            {Object.keys(ticketList).map((osid,index)=>{
                return (
                  <div key={`ticketList-${index}`} className={`${styles.device_card} ${styles.card_details}`}>
                  <div className={`row`}>
                    {/* Device Details Section */}
                    <div className={`col-12`}>
                    <div className={`row`}>
                    <div className={`${styles.heading_wrapper} col-12 ${styles.device_section}`}>
                        <p className={`${styles.details} ${styles.card_title}`}>
                          {getDeviceName(osid)}
                          {landed_on_page === '' ? <a className={styles.device_selection__edit} onClick={() => { handleEditOption(14,osid) }} href="#" title="Edit selection"></a> : null}
                          <a className={`${styles.device_info} ${styles.delete_device}`} onClick={() => {removeDevice(osid)}} href="#" title="Edit selection"></a>
                        </p>
                        <p className={`${styles.details} ${styles.faded}`}>{ticketList[osid].deviceDetails.brand ? `${ticketList[osid].deviceDetails.brand} ` : ''}{getCategoryText(osid)}</p>
                        {/* ticketList[osid].planDetails.brand ?<p className={styles.details}>Brand : {`${ticketList[osid].planDetails.brand}`}</p> : null */}
                    </div>
                    </div>
                    {/* Plan Details Section */}
                    <div className={`row ${styles.plan_section}`}>
                    <div className={`${styles.heading_wrapper} col-12 col-md-6 col-lg-6`}>
                        {/* <p className={styles.details}>Plan : {ticketList[osid].planDetails.device_detail.brand ? `${ticketList[osid].planDetails.plan_title} - ${ticketList[osid].planDetails.device_detail.brand}` : `${ticketList[osid].planDetails.plan_title}`}</p> */}
                        <div>
                          <h6 className={`${styles.details} ${styles.details_large}`}>
                            Selected Cover {!(ticketList[osid].landed_on_page === 'address') && !(ticketList[osid].addressPageFrom === 3)
                              ? <a className={styles.device_selection__edit} onClick={() => {handleEditOption(4,osid)}} href="#" title="Edit selection"></a>
                              : null}
                          </h6>
                          <p key = {`problemList-${index}`} className={`${styles.details} ${styles.faded}`}>{ticketList[osid].serviceRequests[0].selected_cover.cover_details[0].cover_title}</p>
                        </div>
                    </div>
                    <div className={`${styles.heading_wrapper} col-12 col-md-6 col-lg-6`}>
                        <div>
                          <h6 className={`${styles.details} ${styles.details_large}`}>
                            Issues Selected {!(landed_on_page === 'address') && !(addressPageFrom === 3) && !(ticketList[osid].serviceRequests[0].selected_cover.cover_details[0].type === "service")
                              ? <a className={styles.device_selection__edit} onClick={() => {handleEditOption(5,osid)}} href="#" title="Edit selection"></a>
                              : null}
                          </h6>
                          {getProblemsList(ticketList[osid].serviceRequests).map((item,index)=>{
                              return <p key = {`problemList-${index}`} className={`${styles.details} ${styles.faded}`}>{item}</p>
                          })}
                      </div>
                    </div>

                    </div>
                    </div>
                  </div>
                  </div>
                )
            })}

            {HOMECARE_PLAN_LIST.includes(planName)
                &&
                landed_on_page === ''
                ?
                <div className={`${styles.add_more_devices} ${getMaxClaimValidity() ? '' : styles.disabled }`}
                    onClick={() =>  handleRaiseNewSR()}
                    title="Edit selection">
                    <div className={styles.wrapper}>
                      <div className={styles.add_more_devices__icon}><p>+</p></div>
                      <div className={styles.add_more_devices__text}>Would you like to service more devices?</div>
                    </div>
                </div>: null}
            {showChildPlan &&
                <div>
                  {props.selfserveReducer.parentPlanDetails.plan_name !== "HomeCare Comprehensive" &&
                  <p className={styles.common_heading}>Select Previously Serviced Devices:</p>
                  }
                  <div>
                      <ChildPlanList
                          props={props}
                          setPageLoading={props.setPageLoading}
                          setDisableBtn={setDisableBtn}
                          setCoversNo={setCoversNo}
                          is_new_device_info={true}
                      />
                      {props.selfserveReducer.parentPlanDetails.hcb_serviced_devices.length > 0 && <p className={styles.common_heading}>OR</p>}
                      {props.selfserveReducer.parentPlanDetails.hcb_serviced_devices.length < 1 && (props.selfserveReducer.parentPlanDetails.plan_name !== "HomeCare Comprehensive") && <p style={{margin: 12, fontSize: 14}}>No Devices Found</p>}
                      {HOMECARE_PLANS.includes(planName) &&
                          <div
                              className={styles.add_new_device}
                              onClick={() => {
                                  setIsOpenDeviceModel(!isOpenDeviceModel)
                              }}>
                              <div className={styles.add_more_devices}>
                                <div className={styles.add_device_button}>
                                    Add New Device
                                </div>
                              </div>
                          </div>
                      }

                      {isOpenDeviceModel && <AddDeviceModal
                          is_open={isOpenDeviceModel}
                          setEnableModal={setIsOpenDeviceModel}
                          setDisableBtn={setDisableAddNewDevice}
                          disableBtn={disableAddNewDevice}
                          deviceDetails={deviceDetails}
                          setDeviceDetails={setDeviceDetails} />
                      }
                  </div>
                </div>
            }
            {isOpenDeviceDeleteModel &&
                <ConfirmDeleteDeviceModel
                    is_open={isOpenDeviceDeleteModel}
                    setEnableModal={setIsOpenDeviceDeleteModel}
                    deviceKey={deleteDeviceKey}
                />
            }
            <div className={commonStyles.button_actions_sticky} data-varient='sticky'>
                 {/* PREVIOUS BUTTON */}
                {previousStepList.length > 0 &&
                    <Button
                        disabled={landed_on_page === 'covers'}
                        className={commonStyles.cart_btn}
                        text={'Previous'}
                        variant='secondary'
                        onClick={() => {
                            dispatch(previousStepProgress(currentTicketKey));
                        }}
                    />
                }
                <Button
                    className={commonStyles.cart_btn}
                    text={!editScreen.isEditing ? 'Next' : 'Done'}
                    variant='primary'
                    onClick={(e) => { handleButton(e) }}
                />


            </div>

        </div>
    )

}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect<ReduxStateProps>(mapStateToProps)(DeviceInformation);
